import { createApp } from 'vue';
import OfferContact from './OfferContact.vue';

export const initOfferContact = () => {
  if (!document.getElementById('offer-contact-app')) {
    return;
  }

  createApp(OfferContact)
    .mount('#offer-contact-app');
};
